module.exports = __webpack_public_path__ + "static/Prof.JeanneAdiwinataPMDPhD-98cb80de0dc85d6e71cd0beb15e74e2d.jpg";